/** Big tiles to pick one thing from: an operation, an amount, a destination. */
import { z } from 'zod';
import { defineWidget } from '../contract';
import { intentSchema, run } from '../intent';
import { Icon } from '../../ui-kit/Icon';
import { Panel } from '../../ui-kit/Panel';
import css from '../Widgets.module.css';

const schema = z.object({
  title: z.string().optional(),
  subtitle: z.string().optional(),
  icon: z.string().optional(),
  columns: z.number().int().min(1).max(4).default(2),
  options: z.array(z.object({
    id: z.string(),
    label: z.string(),
    sub: z.string().optional(),
    icon: z.string().optional(),
    selected: z.boolean().default(false),
    disabled: z.boolean().default(false),
    intent: intentSchema,
  })).min(1),
});

export const choiceGrid = defineWidget({
  key: 'choice-grid',
  schema,
  Component: ({ props, api }) => (
    <Panel title={props.title} subtitle={props.subtitle} icon={props.icon}>
      <div className={css.grid} style={{ gridTemplateColumns: `repeat(${props.columns}, 1fr)` }}>
        {props.options.map((o) => (
          <button key={o.id} className={`${css.tile} ${o.selected ? css.selected : ''}`} disabled={o.disabled}
            onClick={() => run(api, o.intent)} aria-pressed={o.selected}>
            {o.icon && <Icon name={o.icon} size={56} />}
            <span className={css.tileLabel}>{o.label}</span>
            {o.sub && <span className={css.tileSub}>{o.sub}</span>}
          </button>
        ))}
      </div>
    </Panel>
  ),
});
